import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.167 1.66671C13.167 1.20647 12.7939 0.833374 12.3337 0.833374C11.8734 0.833374 11.5003 1.20647 11.5003 1.66671V2.50004H6.50033V1.66671C6.50033 1.20647 6.12723 0.833374 5.66699 0.833374C5.20676 0.833374 4.83366 1.20647 4.83366 1.66671V2.50004H3.16699C1.78628 2.50004 0.666992 3.61933 0.666992 5.00004V16.6667C0.666992 18.0474 1.78628 19.1667 3.16699 19.1667H14.8337C16.2144 19.1667 17.3337 18.0474 17.3337 16.6667V5.00004C17.3337 3.61933 16.2144 2.50004 14.8337 2.50004H13.167V1.66671ZM15.667 7.50004V5.00004C15.667 4.5398 15.2939 4.16671 14.8337 4.16671H13.167V5.00004C13.167 5.46028 12.7939 5.83337 12.3337 5.83337C11.8734 5.83337 11.5003 5.46028 11.5003 5.00004V4.16671H6.50033V5.00004C6.50033 5.46028 6.12723 5.83337 5.66699 5.83337C5.20676 5.83337 4.83366 5.46028 4.83366 5.00004V4.16671H3.16699C2.70675 4.16671 2.33366 4.5398 2.33366 5.00004V7.50004H15.667ZM2.33366 9.16671H15.667V16.6667C15.667 17.1269 15.2939 17.5 14.8337 17.5H3.16699C2.70675 17.5 2.33366 17.1269 2.33366 16.6667V9.16671Z"
	})
});
export default SvgCalendarAlt;
